import authSagas from "./Auth/sagas";

function* sagas() {
  yield authSagas();
}

export default sagas;
